import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Download, FileText, Trash2 } from 'lucide-react';
import { downloadExport } from './PricingShared';

const AffiliatesTab = ({ affiliates, affiliateSort, setAffiliateSort, selectedMonth, onDeleteAffiliate, onShowForm, API }) => {
  return (
    <Card className="border-gray-200 bg-white">
      <div className="p-4 border-b border-gray-200 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <h3 className="text-lg font-bold">Affiliate Partners</h3>
          <Select value={affiliateSort} onValueChange={setAffiliateSort} data-testid="affiliate-sort">
            <SelectTrigger className="w-48"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="revenue">Sort by Revenue</SelectItem>
              <SelectItem value="compression">Sort by Compression</SelectItem>
              <SelectItem value="risk">Sort by Risk</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => downloadExport(`${API}/api/pricing/export/affiliates.csv?month=${encodeURIComponent(selectedMonth)}`)} data-testid="export-affiliates-csv">
            <Download className="h-4 w-4 mr-1" />CSV
          </Button>
          <Button variant="outline" size="sm" onClick={() => downloadExport(`${API}/api/pricing/export/affiliates.pdf?month=${encodeURIComponent(selectedMonth)}`)} data-testid="export-affiliates-pdf">
            <FileText className="h-4 w-4 mr-1" />PDF
          </Button>
          <Button onClick={onShowForm} className="bg-red-600 hover:bg-red-700" data-testid="add-affiliate-btn">
            <Plus className="h-4 w-4 mr-2" />Add Affiliate
          </Button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="affiliates-table">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">Affiliate Name</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">Email</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Bookings</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Total Revenue</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Total Profit</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Avg Discount</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Risk Score</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-600 w-16">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {affiliates.map((affiliate) => (
              <tr key={affiliate.affiliate_id} className="hover:bg-gray-50 transition-colors" data-testid={`affiliate-row-${affiliate.affiliate_id}`}>
                <td className="py-3 px-4 text-sm font-semibold">{affiliate.affiliate_name}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{affiliate.contact_email || '-'}</td>
                <td className="py-3 px-4 text-sm text-right">{affiliate.total_bookings}</td>
                <td className="py-3 px-4 text-sm text-right font-semibold text-green-700">${affiliate.total_revenue}</td>
                <td className="py-3 px-4 text-sm text-right font-semibold text-blue-700">${affiliate.total_profit}</td>
                <td className="py-3 px-4 text-sm text-right">{affiliate.avg_discount_impact}%</td>
                <td className="py-3 px-4 text-sm text-right">
                  <span className={`font-bold ${affiliate.risk_score > 50 ? 'text-red-600' : affiliate.risk_score > 25 ? 'text-yellow-600' : 'text-green-600'}`}>{affiliate.risk_score}%</span>
                </td>
                <td className="py-3 px-4 text-center">
                  <Button variant="ghost" size="sm" onClick={() => onDeleteAffiliate(affiliate.affiliate_id)} className="hover:bg-red-50" data-testid={`delete-affiliate-${affiliate.affiliate_id}`}>
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {affiliates.length === 0 && <div className="text-center py-12 text-gray-500">No affiliates added. Click "Add Affiliate" to create one.</div>}
      </div>
    </Card>
  );
};

export default AffiliatesTab;
